"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneNumberSMSCompatibilityError = exports.phoneNumberSMSCompatibilityDetails = exports.isValidPhoneType = exports.PhoneNumberUtils = void 0;
var _libphonenumberJs = _interopRequireDefault(require("libphonenumber-js"));
var ls = _interopRequireWildcard(require("local-storage"));
var _types = require("../types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DEFAULT_COUNTRY_CODE = 'US';
var PHONE_COUNTRY_CODE_LS_ITEM_NAME = 'PHONE_COUNTRY_CODE'.split('').reverse().join('');
var getLsPhoneNumberCountryCode = function getLsPhoneNumberCountryCode() {
  return ls.get(PHONE_COUNTRY_CODE_LS_ITEM_NAME);
};
var getPhoneNumberCountryCode = function getPhoneNumberCountryCode() {
  return getLsPhoneNumberCountryCode() || DEFAULT_COUNTRY_CODE;
};
var isValidPhoneType = function isValidPhoneType(phoneType) {
  if (!phoneType) {
    return null;
  }
  return phoneType !== _types.PhoneType.Invalid && phoneType !== _types.PhoneType.Landline;
};
exports.isValidPhoneType = isValidPhoneType;
var phoneNumberSMSCompatibilityError = function phoneNumberSMSCompatibilityError(_ref) {
  var phoneDeliveryPreference = _ref.phoneDeliveryPreference,
    phoneSmsCompatible = _ref.phoneSmsCompatible,
    phoneType = _ref.phoneType,
    phoneStatus = _ref.phoneStatus;
  if (phoneDeliveryPreference === _types.DeliveryPreference.Stopped) {
    return {
      status: 'error',
      message: 'SMS Blocked',
      description: "Reply with \"START\" to ".concat(process.env.REACT_APP_TWILIO_PHONE_NUMBER, " to enable SMS notifications")
    };
  } else if (isValidPhoneType(phoneType) === false) {
    return {
      status: 'error',
      message: 'Can’t receive SMS',
      description: 'This number cannot receive SMS. Please use a different number.'
    };
  } else if (isArchivedPhoneNumber(phoneStatus)) {
    return {
      status: 'error',
      message: 'Number is archived',
      description: 'Please contact support.'
    };
  } else if (isUnverifiedPhoneNumber(phoneStatus)) {
    return {
      status: 'warning',
      message: 'Unverified number'
    };
  } else if (phoneSmsCompatible === false) {
    return {
      status: 'error',
      message: 'SMS Delivery Failed',
      description: 'We were unable to send SMS to your phone number.'
    };
  }
  return null;
};
exports.phoneNumberSMSCompatibilityError = phoneNumberSMSCompatibilityError;
var phoneNumberSMSCompatibilityDetails = function phoneNumberSMSCompatibilityDetails(_ref2) {
  var phoneDeliveryPreference = _ref2.phoneDeliveryPreference,
    phoneSmsCompatible = _ref2.phoneSmsCompatible,
    phoneType = _ref2.phoneType,
    phoneStatus = _ref2.phoneStatus;
  var error = phoneNumberSMSCompatibilityError({
    phoneDeliveryPreference: phoneDeliveryPreference,
    phoneSmsCompatible: phoneSmsCompatible,
    phoneType: phoneType,
    phoneStatus: phoneStatus
  });
  if (error) {
    return error;
  }
  if (isActivePhoneNumber(phoneStatus)) {
    return {
      status: 'success',
      message: 'Verified number'
    };
  }
  if (phoneSmsCompatible) {
    return {
      status: 'success',
      message: 'SMS Compatible',
      description: 'SMS notifications can be delivered to this phone number'
    };
  }
  return null;
};
exports.phoneNumberSMSCompatibilityDetails = phoneNumberSMSCompatibilityDetails;
var displayFullPhoneNumber = function displayFullPhoneNumber(number) {
  if (!number) {
    return '';
  }
  var parsedNumber = (0, _libphonenumberJs.default)(number, getPhoneNumberCountryCode());
  if (!parsedNumber || !parsedNumber.isValid()) {
    return '';
  }
  return parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.number;
};
var getNationalNumber = function getNationalNumber(number) {
  if (!number) {
    return '';
  }
  var parsedNumber = (0, _libphonenumberJs.default)(number, getPhoneNumberCountryCode());
  if (!parsedNumber || !parsedNumber.isValid()) {
    return '';
  }
  return parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.nationalNumber;
};
var isTrulyActivePhoneNumber = function isTrulyActivePhoneNumber(status) {
  return status === _types.PhoneNumberStatus.Active;
};
var isActivePhoneNumber = function isActivePhoneNumber(status) {
  return _types.ACTIVE_NUMBER_STATUSES.includes(status);
};
var isPendingVerificationPhoneNumber = function isPendingVerificationPhoneNumber(status) {
  return status === _types.PhoneNumberStatus.PendingVerification;
};
var isActiveNotVerifiedPhoneNumber = function isActiveNotVerifiedPhoneNumber(status) {
  return status === _types.PhoneNumberStatus.ActiveNotVerified;
};
var isArchivedPhoneNumber = function isArchivedPhoneNumber(status) {
  return status === _types.PhoneNumberStatus.Archived;
};
var isUnverifiedPhoneNumber = function isUnverifiedPhoneNumber(status) {
  return isPendingVerificationPhoneNumber(status) || isActiveNotVerifiedPhoneNumber(status);
};
var PhoneNumberUtils = {
  displayFullPhoneNumber: displayFullPhoneNumber,
  isActivePhoneNumber: isActivePhoneNumber,
  isPendingVerificationPhoneNumber: isPendingVerificationPhoneNumber,
  isArchivedPhoneNumber: isArchivedPhoneNumber,
  isUnverifiedPhoneNumber: isUnverifiedPhoneNumber,
  isTrulyActivePhoneNumber: isTrulyActivePhoneNumber,
  getNationalNumber: getNationalNumber,
  getLsPhoneNumberCountryCode: getLsPhoneNumberCountryCode,
  getPhoneNumberCountryCode: getPhoneNumberCountryCode
};
exports.PhoneNumberUtils = PhoneNumberUtils;